import { Navigate, Outlet } from "react-router-dom";
import { useCurrentGym } from "../../../hooks/gym/useCurrentGym";
import { LoadingSpinner } from "../loadingSpinner";
import type { ModulesSettings } from "../../../utils/zod/gym";

interface ModuleProtectedRouteProps {
  module: keyof ModulesSettings | (keyof ModulesSettings)[];
  redirectPath?: string;
}

export const ModuleProtectedRoute = ({
  module,
  redirectPath = "/profile",
}: ModuleProtectedRouteProps) => {
  const { data: gym, isLoading } = useCurrentGym();

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <LoadingSpinner />
      </div>
    );
  }

  const modules = Array.isArray(module) ? module : [module];
  const enabled = modules.some(
    (m) => gym?.modulesSettings?.[m]?.enabled ?? false,
  );

  if (!enabled) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
